<template>
  <div class="main-body">
    <div class="header">视频监控</div>
    <div class="out">
      <div class="search2">
        <el-button size="mini" type="primary" plain @click.native="toggleModalAdd">添加</el-button>
        <el-button size="mini" type="success" plain @click="toggleModalViewPlus">视频预览</el-button>

        <div style="float: right;">

          <el-select v-model="institutionCode" placeholder="请选择机构" style="margin-right:10px">
            <el-option
                v-for="item in arr_ins"
                :key="item.institutionCode"
                :label="item.userName"
                :value="item.institutionCode">
            </el-option>
          </el-select>

          <el-button size="mini" type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" v-loading="tableLoading" :data="tableData" :height="th"
                @selection-change="handleSelectionChange"
                border >

        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column prop="sn" label="序列号"></el-table-column>
        <el-table-column prop="yzm" label="验证码"></el-table-column>
        <el-table-column prop="tdh" label="通道号"></el-table-column>
        <el-table-column fixed="right" label="操作" width="250">
          <template slot-scope="scope">

            <el-button size="mini" type="text" @click="viewCamera(scope.$index, scope.row)">查看</el-button>
            <el-button size="mini" type="text" @click="viewCameraBack(scope.$index, scope.row)">回放</el-button>
            <el-button size="mini" type="text" @click="formatSD(scope.$index, scope.row)">SD卡格式化</el-button>

            <el-button type="text" size="mini" @click="RemoveBinding(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small background layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="pageSize"
                         :current-page.sync="currentPage"
                         @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>


    <Add ref="myAdd" v-show="showModalAdd" v-bind:arr_ins="arr_ins" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
    <ViewPlus ref="myViewPlus" v-show="showModalViewPlus" v-on:closeViewPlus="closeViewPlus"></ViewPlus>

    <ViewCameraH5 ref="myViewCameraH5" v-show="showCamera" v-on:closeCamera="showCamera=false"></ViewCameraH5>
    <ViewCameraH5Back ref="myViewCameraH5Back" v-show="showCameraH5Back" v-on:closeCamera="showCameraH5Back=false"></ViewCameraH5Back>


    <div v-if="showModal" class="mask">
      <div class="lodingsIcon">
        <i class="el-icon-loading"></i><span>格式化进行中({{formatRate}})...</span>
      </div>
    </div>


  </div>
</template>

<script>
import { timeStr,timefilters } from "@/common/times";
import { hex_md5 } from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";


import Add from "./Add";
import ViewPlus from "./../Ins/ViewPlus";

import ViewCameraH5 from "@/views/Device/Camera/Comm/ViewCameraH5";
import ViewCameraH5Back from "@/views/Device/Camera/Comm/ViewCameraH5Back";


export default {
  name: "Page",
  data() {
    return {
      tableLoading:false,

      showModal:false,
      showModalAdd:false,
      showModalViewPlus:false,

      showCamera:false,
      showCameraH5Back:false,

      tableData: [],
      totalItems: 0,
      pageSize: 8,
      currentPage: 1,

      th: 0,

      multipleSelection:'',

      arr_ins:[],
      institutionCode: '',

      formatRate:0,

    };
  },
  components: {
    ViewPlus,Add,ViewCameraH5,ViewCameraH5Back
  },
  created() {
    this.getIns();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    "$store.state.tableHeight": function (val) {
      this.th = val;
    },
  },
  methods: {

    toggleModalViewPlus:function(){
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        this.$message({type: 'warning', message: '请选择摄像头'});
        return;
      }

      this.$refs.myViewPlus.init2(this.multipleSelection);
      this.showModalViewPlus = !this.showModalViewPlus;
    },
    closeViewPlus:function(){
      this.showModalViewPlus = !this.showModalViewPlus;
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },


    getIns(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Institution/ListType",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          type:1,
        }
      }).then((response) => {

        if (response.data.error === 0) {
          this.arr_ins = response.data.data.list;
          if(this.arr_ins.length>0){
            this.institutionCode = this.arr_ins[0].institutionCode;
            this.getList();
          }
        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }

      })

    },

    toggleModalAdd:function(){
      this.$refs.myAdd.init();
      this.showModalAdd = !this.showModalAdd;
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },


    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    getList(){
      var _this=this
      this.tableLoading=true

      this.$axios({
        method: "post",
        url: this.$deviceUrl + "GroupCamera/PageByInstitutionCode",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
          institutionCode:this.institutionCode,
        },
      }).then((response) => {
        _this.tableLoading=false
        if (response.data.error == 0) {
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }
      }).catch(function (error) {
        _this.tableLoading=false
        console.log(error);
      });
    },

    timefilter(row, column, cellValue) {
      return timefilters(cellValue);
    },

    RemoveBinding(row) {
      this.$confirm("您确定要删除该设备吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios({
          method: "post",
          url: this.$deviceUrl + "GroupCamera/Delete",
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            groupCameraCode: row.groupCameraCode,
          },
        }).then((response) => {
          //console.log(response);
          if (response.data.error == 0) {
            //this.$message({message: "删除成功", type: "success",});
            this.getList();
          } else if (response.data.error == 1) {
            this.$message.error(response.data.message);
          }
        }).catch(function (error) {
          console.log(error);
        });

      }).catch(() => {
            //this.$message({type: "info", message: "已取消操作",});
          });
    },


    viewCamera(index,row){
      this.$refs.myViewCameraH5.init(row.sn,row.tdh);
      this.showCamera =!this.showCamera;
    },
    viewCameraBack(index,row){
      this.$refs.myViewCameraH5Back.init(row.sn,row.tdh);
      this.showCameraH5Back =!this.showCameraH5Back;
    },

    formatSD(index,row){

      let that = this;

      this.$confirm("您确定要格式化SD卡吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {



        this.$axios({
          method: "post",
          url: this.$deviceUrl + "DeviceCamera/FormatBySN",
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            sn: row.sn,
          },
        }).then((response) => {
          console.log(response);

          if (response.data.data.code == 200) {
            this.$message({message: "格式化已启动", type: "success",});

            this.showModal = true;
            setTimeout(function (){that.getFormatRate(row);},5000);

          } else {
            this.$message.error(response.data.data.msg);
          }


        }).catch(function (error) {
          console.log(error);
        });


      }).catch(() => {
        //this.$message({type: "info", message: "已取消解绑",});
      });

    },
    getFormatRate(row){

      let that = this;

      this.$axios({
        method: "post",
        url: this.$deviceUrl + "DeviceCamera/FormatRateBySN",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          sn: row.sn,
        },
      }).then((response) => {
        //console.log(response);

        if(response.data.data.code== 200){
          let data = response.data.data.data;
          let formattingRate = data.formattingRate;
          //console.log(formattingRate);

          this.formatRate = formattingRate;

          if(formattingRate<100){
            setTimeout(function (){that.getFormatRate(row);},5000);
          }else{
            this.$message({type: "info", message: "格式化完成",});
            this.showModal = false;
            this.openRecord(row);
          }

        }


      }).catch(function (error) {
        console.log(error);
      });


    },
    openRecord(row){

      this.$axios({
        method: "post",
        url: this.$deviceUrl + "DeviceCamera/OpenRecordBySN",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          sn: row.sn,
          tdh:row.tdh
        },
      }).then((response) => {
        console.log(response);

      }).catch(function (error) {
        console.log(error);
      });

    },



  },
};
</script>

